export const AI_APP_STORE_LABEL = 'AI App Store';
export const EXTERNAL_RESOURCE_LABEL = 'External Resource';
export const INTELLIO_ADVANTAGE_LABEL = 'Intellio Advantage';

export const PROMPT_FILTER_GROUPS = ['General', 'Industry', 'Practice', 'Discipline'] as const;

export const APP_STORE_FILTER_GROUPS = [
  'App Classification',
  'Target Industry',
  'Functional Expert',
  'Practice Domain',
] as const;

export const SYSTEM_MANAGED_PROMPT_TAGS = [AI_APP_STORE_LABEL, EXTERNAL_RESOURCE_LABEL] as const;

export const HIDDEN_PROMPT_FORM_TAGS = [
  AI_APP_STORE_LABEL,
  INTELLIO_ADVANTAGE_LABEL,
  EXTERNAL_RESOURCE_LABEL,
] as const;
